export default __webpack_public_path__ + "social-development_sm@2x.52b7e9ee.png";